import { Injectable } from '@angular/core';
import { Router, CanActivate, CanLoad, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SystemUser } from './models/User';
import * as _ from 'lodash';
import { MatSnackBar } from '@angular/material';
 
@Injectable()
export class AuthGuard implements CanActivate, CanLoad, CanActivateChild {
 
    constructor(private router: Router, private snackbar: MatSnackBar) { }
 
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        if (localStorage.getItem('USER')) {

            let user:SystemUser = JSON.parse(localStorage.getItem('USER').valueOf())
            
            try {
                if(_.intersection(user.roles, route.data.roles).length > 0){
                    return true
                }
                else {
                    this.snackbar.open("You don't have the required privileges", "Unauthorized", {duration:3000, verticalPosition:'top'})
                    return false
                }
            } catch (error) {
                this.snackbar.open(error, "error", {duration:3000, verticalPosition:'top'})
                return false
            }

        }

        this.router.navigate(['/login']);
        return false;
    }

    canLoad() {
        let user = JSON.parse(localStorage.getItem('USER'))
        if (user) {
            if (user.roles.includes("ROLE_ADMIN") || 
                user.roles.includes("ROLE_USER_MAN") || 
                user.roles.includes("ROLE_USER_MANAGER")) {
                return true;
            }
        }
        //show some not authorized message
        return false;
    }

    canActivateChild(){

        console.log('can activate child called')

        if (JSON.parse(localStorage.getItem('USER').valueOf())) {
            return true;
        }
        this.router.navigate(['/login']);
        return false;
    }
}